import React from 'react';
import {
  Box,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import BuildIcon from '@mui/icons-material/Build';
import GroupIcon from '@mui/icons-material/Group';
import { Link } from 'react-router-dom';

const LINKS = [
  { to: '/', label: 'キャラクター', icon: <HomeIcon /> },
  { to: '/accessories', label: '装飾品管理', icon: <BuildIcon /> },
  { to: '/partymanagement', label: '編成管理', icon: <GroupIcon /> },
];

export default function Menu({ open, onClose }) {
  return (
    <Drawer anchor="left" open={open} onClose={onClose}>
      <Box sx={{ width: 260 }} role="presentation" onClick={onClose}>
        <Box sx={{ p: 2, backgroundColor: 'background.paper', borderBottom: '1px solid', borderColor: 'divider' }}>
          <Typography variant="h6">メニュー</Typography>
        </Box>
        <Divider />
        <List>
          {LINKS.map((item) => (
            <ListItem key={item.to} disablePadding>
              <ListItemButton component={Link} to={item.to}>
                <ListItemIcon>{item.icon}</ListItemIcon>
                <ListItemText primary={item.label} />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Box>
    </Drawer>
  );
}
